import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useGetAllEverifyUsers(search = "") {
  return useQuery({
    queryKey: ["everifyUsers", search],
    queryFn: async () => {
      const { data } = await api.post("/user/getalleverifyusers", {
        pageSize: 1000,
        search: search ?? "",
        status: [],
        pageNumber: 1,
      });

      return Array.isArray(data.result) ? data.result : [];
    },
    staleTime: 1000 * 60 * 5, // cache for 5 min
  });
}
